import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { AbortError } from "@azure/abort-controller";
import { Constants } from "../util/constants";
import { DEFAULT_CLIENT_MAX_RETRY_COUNT } from "../util/throttlingRetryStrategy";
import { delay } from "../util/delay";
var StatusCodes = Constants.HttpConstants.StatusCodes;
/**
 * Creates a policy that re-sends the request if the response indicates the request failed because of throttling reasons.
 * For example, if the response contains a `Retry-After` header, it will retry sending the request based on the value of that header.
 *
 * To learn more, please refer to
 * https://docs.microsoft.com/en-us/azure/azure-resource-manager/resource-manager-request-limits,
 * https://docs.microsoft.com/en-us/azure/azure-subscription-service-limits and
 * https://docs.microsoft.com/en-us/azure/virtual-machines/troubleshooting/troubleshooting-throttling-errors
 * @returns
 */

export function throttlingRetryPolicy() {
  return {
    create: function create(nextPolicy, options) {
      return new ThrottlingRetryPolicy(nextPolicy, options);
    }
  };
}
var StandardAbortMessage = "The operation was aborted.";
/**
 * Creates a policy that re-sends the request if the response indicates the request failed because of throttling reasons.
 * For example, if the response contains a `Retry-After` header, it will retry sending the request based on the value of that header.
 *
 * To learn more, please refer to
 * https://docs.microsoft.com/en-us/azure/azure-resource-manager/resource-manager-request-limits,
 * https://docs.microsoft.com/en-us/azure/azure-subscription-service-limits and
 * https://docs.microsoft.com/en-us/azure/virtual-machines/troubleshooting/troubleshooting-throttling-errors
 */

export var ThrottlingRetryPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(ThrottlingRetryPolicy, _BaseRequestPolicy);

  var _super = _createSuper(ThrottlingRetryPolicy);

  function ThrottlingRetryPolicy(nextPolicy, options, _handleResponse) {
    var _this;

    _classCallCheck(this, ThrottlingRetryPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.numberOfRetries = 0;
    _this._handleResponse = _handleResponse || _this._defaultResponseHandler;
    return _this;
  }

  _createClass(ThrottlingRetryPolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpRequest) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._nextPolicy.sendRequest(httpRequest.clone());

              case 2:
                response = _context.sent;

                if (!(response.status !== StatusCodes.TooManyRequests && response.status !== StatusCodes.ServiceUnavailable)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", response);

              case 7:
                return _context.abrupt("return", this._handleResponse(httpRequest, response));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: "_defaultResponseHandler",
    value: function () {
      var _defaultResponseHandler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(httpRequest, httpResponse) {
        var _a, retryAfterHeader, delayInMs;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                retryAfterHeader = httpResponse.headers.get(Constants.HeaderConstants.RETRY_AFTER);

                if (!retryAfterHeader) {
                  _context2.next = 14;
                  break;
                }

                delayInMs = ThrottlingRetryPolicy.parseRetryAfterHeader(retryAfterHeader);

                if (!delayInMs) {
                  _context2.next = 14;
                  break;
                }

                this.numberOfRetries += 1;
                _context2.next = 7;
                return delay(delayInMs, undefined, {
                  abortSignal: httpRequest.abortSignal,
                  abortErrorMsg: StandardAbortMessage
                });

              case 7:
                if (!((_a = httpRequest.abortSignal) === null || _a === void 0 ? void 0 : _a.aborted)) {
                  _context2.next = 9;
                  break;
                }

                throw new AbortError(StandardAbortMessage);

              case 9:
                if (!(this.numberOfRetries < DEFAULT_CLIENT_MAX_RETRY_COUNT)) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", this.sendRequest(httpRequest));

              case 13:
                return _context2.abrupt("return", this._nextPolicy.sendRequest(httpRequest));

              case 14:
                return _context2.abrupt("return", httpResponse);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _defaultResponseHandler(_x2, _x3) {
        return _defaultResponseHandler2.apply(this, arguments);
      }

      return _defaultResponseHandler;
    }()
  }], [{
    key: "parseRetryAfterHeader",
    value: function parseRetryAfterHeader(headerValue) {
      var retryAfterInSeconds = Number(headerValue);

      if (Number.isNaN(retryAfterInSeconds)) {
        return ThrottlingRetryPolicy.parseDateRetryAfterHeader(headerValue);
      } else {
        return retryAfterInSeconds * 1000;
      }
    }
  }, {
    key: "parseDateRetryAfterHeader",
    value: function parseDateRetryAfterHeader(headerValue) {
      try {
        var now = Date.now();
        var date = Date.parse(headerValue);
        var diff = date - now;
        return Number.isNaN(diff) ? undefined : diff;
      } catch (error) {
        return undefined;
      }
    }
  }]);

  return ThrottlingRetryPolicy;
}(BaseRequestPolicy);